<h3 mat-dialog-title>Filtrar Custódia Consolidada</h3>
<div mat-dialog-content style="width: 100%">

    <div fxLayout="column" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" fxFlex="24" style="margin-right: 10px;">
            <mat-label>Tipo de Cliente</mat-label>
            <mat-select                  
                [(ngModel)]="model.tipo_cliente"  
                name="tipo_cliente"
                [formControl]="tipo_cliente" >
                <mat-option value="">Todos</mat-option>
                <mat-option value="true">Home Broker</mat-option>
                <mat-option value="false">MRV</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="74">
            <mat-label>Tipo Custódia</mat-label>
            <mat-select                  
                [(ngModel)]="model.tipo_custodia"  
                name="tipo_custodia"
                [formControl]="tipo_custodia">
                <mat-option value="">Todos</mat-option>                
                <mat-option value="disponivel">Custódia Disponivel</mat-option>
                <mat-option value="ativo_bloqueado">Custódia Bloqueada</mat-option>
                <mat-option value="ativo_coberto">Custódia com Financiamento Coberto</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
            <mat-label>Cliente</mat-label>
            <input matInput placeholder="Digite o nome ou conta de um cliente" aria-label="Cliente"  [formControl]="cliente" name="cliente" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"  (optionSelected)='getCliente($event.option.value)'>
                <mat-option *ngFor="let cliente of filteredOptions | async" [value]="cliente">
                    <span> {{cliente.nome}}</span> |
                    <small>Conta: {{cliente.numero_xp }}</small>
                </mat-option>
            </mat-autocomplete>
            <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
            <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
        </mat-form-field>
    </div>

    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
            <mat-label>Ativo</mat-label>
            <input matInput placeholder="Digite o ativo" aria-label="Ativo"  [formControl]="ativo" name="ativo" [matAutocomplete]="auto2">
            <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFnAtivo"  (optionSelected)='getAtivo($event.option.value)'>
                <mat-option *ngFor="let ativo of filteredOptionsAtivo | async" [value]="ativo">
                    <span>Empresa: {{ativo.nome}}</span> |
                    <small>Sigla: {{ativo.sigla }}</small>
                </mat-option>
            </mat-autocomplete>            
            <mat-spinner diameter="20" *ngIf="loadingSpinnerAtivos"></mat-spinner>
        </mat-form-field>
    </div>

    <div fxLayout="column" fxLayout.gt-md="row">
        
        <mat-form-field 
            appearance="outline" 
            *ngIf='usuario.role_id != 5' 
            fxFlex="49"
            style="margin-right: 10px;"
        >
            <mat-label>Escritório</mat-label>
            <mat-select 
                placeholder="Escritório" 
                [(value)]="model.escritorio_id"
                [formControl]="escritorio_id" 
                (selectionChange)="selectEscritorio($event)">
                <mat-option value="">TODOS</mat-option>
                <mat-option *ngFor="let escritorio of listEscritorios"
                    [value]="escritorio.id">{{escritorio.nome_fantasia}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerEscritorio"></mat-spinner> 
        </mat-form-field>

        <mat-form-field 
            appearance="outline" 
            *ngIf='usuario.role_id != 5' 
            fxFlex="49"
        >
            <mat-label>Assessor</mat-label>
            <mat-select placeholder="Assessor"
                        [(value)]="model.assessor_id" 
                        [formControl]="assessor_id"
                        name="assessor_id" >
                <mat-option value="">Selecione...</mat-option>
                <mat-option *ngFor="let assessor of listAssessor" [value]="assessor.id">{{assessor.name}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerAssessor"></mat-spinner>        
        </mat-form-field>

    </div>

    <div fxLayout="column" fxLayout.gt-md="row" >

        <mat-form-field 
            appearance="outline" 
            *ngIf='usuario.role_id != 5' 
            style="margin-right: 10px;"
            fxFlex="49"
        >
            <mat-label>Tipo</mat-label>
            <mat-select 
                placeholder="Tipo"                        
                [formControl]="tipo_percentual"
                name="tipo_percentual" 
            >
                <mat-option value="MA">Maior que</mat-option>
                <mat-option value="ME">Menor que</mat-option>
                <mat-option value="IG">Igual a </mat-option>                
                <mat-option value="DI">Diferente de </mat-option>                
            </mat-select>                   
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="49">
            <mat-label>Percentual</mat-label>
            <input 
                matInput 
                placeholder="00.0%" 
                [formControl]="percentual" 
                name="percentual" 
                maxlength="4"
                mask="00.0 %">
        </mat-form-field>

    </div>
    
    <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="space-between">
        
        <mat-form-field appearance="outline" fxFlex="50">
            <mat-label>Custódia Migrada</mat-label>
            <mat-select                  
                [(ngModel)]="model.migrada"  
                name="migrada"
                [formControl]="migrada">
                <mat-option value="">TODOS</mat-option>
                <mat-option value="true">SIM</mat-option>
                <mat-option value="false">NÃO</mat-option>
            </mat-select>
        </mat-form-field>  
        
        <mat-form-field appearance="outline" fxFlex="49">
            <mat-label>Classficação</mat-label>
            <mat-select 
                placeholder="Classficação do Cliente"
                [(value)]="model.primeiro_contato_id" 
                [formControl]="primeiro_contato_id"
                name="primeiro_contato_id" 
            >
                <mat-option value="">Selecione...</mat-option>
                <mat-option 
                    *ngFor="let classificacao of listClassificacao" 
                    [value]="classificacao.id"
                >
                    {{classificacao.nome}}
                </mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerClassificacao"></mat-spinner>
        </mat-form-field>
    </div>

    <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="space-between">
        <mat-form-field appearance="outline" fxFlex="49">
            <mat-label>Setor</mat-label>
            <mat-select 
                placeholder="Setor"
                [(value)]="model.setor_id" 
                [formControl]="setor_id"
                name="setor_id" 
            >
                <mat-option value="">Selecione...</mat-option>
                <mat-option 
                    *ngFor="let setor of listSetor" 
                    [value]="setor.id"
                >
                    {{setor.nome}}
                </mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerSetor"></mat-spinner>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="49">
            <mat-label>Estratégia</mat-label>
            <mat-select 
                placeholder="Estrategias de Renda Variável"               
                [formControl]="estrategia_id"
                name="estrategia_id" 
            >
                <mat-option value="">Selecione...</mat-option>
                <mat-option 
                    *ngFor="let estrategia of listEstrategia" 
                    [value]="estrategia.id"
                >
                    {{estrategia.nome}}
                </mat-option>
            </mat-select> 
            <mat-spinner diameter="20" *ngIf="loadingSpinnerEstrategia"></mat-spinner>           
        </mat-form-field>
    </div>


</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button (click)="filtrar()" tabindex="-1">Filtrar</button>
</div>